import { Roles } from '../model/role.interface';
import { SidemenuCategory } from '../model/sidemenu-categories.interface';
import { CASTING_CONFIG } from 'src/app/resources/casting-config';

export const COMPANY_SIDE_BAR: SidemenuCategory[] = [
  {
    expand: false,
    links: ['/dashboard'],
    title: 'SIDEBAR.DASHBOARD_TITLE',
    children: [
      {
        title: 'SIDEBAR.VISIT_DASHBOARD_LINK',
        link: '/dashboard/company',
        queryParams: true
      }
    ]
  },
  {
    expand: false,
    links: ['/recruitment'],
    title: 'SIDEBAR.AUDITION_BOARD_TITLE',
    children: [
      {
        title: 'SIDEBAR.HANDLE_AUDITIONS_LINK',
        link: '/recruitment/handle-candidates',
        queryParams: true
      }
    ]
  },
  {
    expand: false,
    links: ['/jobs', '/templates'],
    title: 'SIDEBAR.AUDITIONS_TITLE',
    children: [
      {
        title: 'SIDEBAR.CREATE_NEW_AUDITION_LINK',
        link: '/jobs/job-template-list',
        queryParams: true
      },
      {
        title: 'SIDEBAR.CREATE_NEW_TEMPLATE_LINK',
        link: '/templates/create',
        queryParams: true
      },
      {
        title: 'SIDEBAR.VIEW_CURRENT_AUDITIONS_LINK',
        link: '/jobs/job-list',
        queryParams: true
      },
      {
        title: 'SIDEBAR.VIEW_CURRENT_TEMPLATES_LINK',
        link: '/templates/list',
        queryParams: true
      },
      {
        title: 'SIDEBAR.VIEW_DRAFT_LINK',
        link: '/jobs/job-draft-list',
        queryParams: true
      },
      {
        title: 'SIDEBAR.VIEW_CURRENT_JOBS_TO_BIND_LINK',
        link: '/jobs/job-bind-list',
        allowForRoles: [Roles.companyHR, Roles.enterpriseHR, Roles.enterpriseRM, Roles.companyRM],
        queryParams: true,
        hide: !CASTING_CONFIG.bindingJobs
      },
    ]
  },
  {
    expand: false,
    links: ['/interview'],
    title: 'SIDEBAR.INTERVIEWS_BOARD_TITLE',
    children: [
      {
        title: 'SIDEBAR.CREATE_INDIVIDUAL_INTERVIEW',
        link: '/interview/application-interview',
        queryParams: true
      },
      {
        title: 'SIDEBAR.CREATE_GROUP_INTERVIEW',
        link: '/interview/group-interview',
        queryParams: true
      },
      {
        title: 'SIDEBAR.HANDLE_INDIVIDUAL_INTERVIEWS',
        link: '/interview/application-interview-list',
        queryParams: true
      },
      {
        title: 'SIDEBAR.HANDLE_GROUP_INTERVIEWS',
        link: '/interview/group-interview-list',
        queryParams: true
      },
      {
        title: 'SIDEBAR.INTERVIEW_LIBRARY',
        link: '/interview/interview-library',
        queryParams: true
      }
    ]
  },
  {
    expand: false,
    links: ['/marketplace'],
    title: 'SIDEBAR.MARKETPLACE_TITLE',
    children: [
      {
        title: 'SIDEBAR.STAFFING_AND_RECRUITMENT_LINK',
        link: '/marketplace/staffing-and-recruitment',
        queryParams: true
      }
    ],
    hide: !CASTING_CONFIG.marketplace
  },
  {
    expand: false,
    links: ['/support-and-feedback', '/users', '/hr'],
    title: 'SIDEBAR.SETTINGS_TITLE',
    children: [
      {
        title: 'SIDEBAR.CREATE_NEW_USER_AND_PROJECT_LINK',
        link: '/users/user-branch-management',
        allowForRoles: [Roles.companyHR, Roles.enterpriseHR, Roles.enterpriseRM],
        queryParams: true
      },
      {
        title: 'SHARED.USER_PROFILE',
        link: '/users/user-profile',
        allowForRoles: [Roles.companyHR, Roles.companyRM, Roles.recruiter]
      },
      {
        title: 'SIDEBAR.SUPPORT_AND_FEEDBACK_LINK',
        link: '/support-and-feedback',
        queryParams: true
      },
      {
        title: 'SIDEBAR.HR',
        link: '/hr/dashboard',
        queryParams: true,
        class: 'd-none d-xl-block',
        allowForRoles: [Roles.companyHR, Roles.enterpriseHR, Roles.enterpriseRM]
      },
      {
        title: 'SIDEBAR.AGREEMENT_FORM_LIST',
        link: '/agreements/agreement-list',
        queryParams: true,
        hide: true
      }
    ]
  },
  {
    expand: false,
    links: ['/kpi-statistics'],
    title: 'SIDEBAR.KPI_AND_STATISTIC_TITLE',
    children: [
      {
        title: 'SIDEBAR.VIEW_KPI_AND_STATISTIC_LINK',
        link: '/kpi-statistics/kpi-select-jobs',
        queryParams: true,
      }
    ]
  },
];

export const COMPANY_SIDE_BAR_WITHOUT_INTERVIEW: SidemenuCategory[] =
  COMPANY_SIDE_BAR.filter(category => category.title !== 'SIDEBAR.INTERVIEWS_BOARD_TITLE');
